import React, { useState, useEffect } from 'react';
import './Timer.css';

const Timer = ({ startTime, endTime, className = '' }) => {
  const [elapsedMs, setElapsedMs] = useState(0);

  useEffect(() => {
    if (endTime) {
      // If we have an end time, just display the final duration
      setElapsedMs(endTime - startTime);
      return;
    }

    // Otherwise, count up from start time
    const interval = setInterval(() => {
      setElapsedMs(Date.now() - startTime);
    }, 1000);

    return () => clearInterval(interval);
  }, [startTime, endTime]);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const milliseconds = Math.floor((ms % 1000) / 100);

    if (minutes > 0) {
      return `${minutes}:${seconds.toString().padStart(2, '0')}.${milliseconds}s`;
    }
    return `${seconds}.${milliseconds}s`;
  };

  return (
    <span className={`timer ${className}`}>
      {formatTime(elapsedMs)}
    </span>
  );
};

export default Timer;
